import { PandoraConfig } from 'data/terra/api/terra/response/PandoraConfigResponse';
import Terra from 'services/apis/terra/Terra';
import { App } from '../data/terra/App';
import { AppVersion } from '../data/terra/AppVersion';
import { PlatformCode } from '../data/terra/ModuleConfig/util';
import { fromJson } from './plist';
import { error, Result, success } from './result';

export const buildTerraConfigObject = (
  terraClientID: string,
  defaultConfig: PandoraConfig
): object => {
  return {
    terraClientID,
    terraEnvironment: getTerraEnv(),
    defaultConfig,
  };
};

export const getTerraEnv = (): string => {
  switch (Terra.TERRA_HOST) {
    case 'https://terra.dev.tekoapis.net':
      return 'dev';
    case 'https://terra.stag.tekoapis.net':
      return 'staging';
    case 'https://terra.tekoapis.com':
      return 'live';
    default:
      throw Error('Cannot detect Terra environment');
  }
};

export async function downloadPandoraConfig(
  app: App,
  appVersion: AppVersion
): Promise<Result<boolean>> {
  const clientId = `${app.product.code}:${app.platform.code}:${app.market.code}:${appVersion.code}`;
  const result = await Terra.frontEnd.fetchPandoraConfig(clientId);
  if (result.isSuccess()) {
    const pandora = result.get()!.data;
    const data = buildTerraConfigObject(clientId, pandora);
    let dataStr = '';
    if (app.platform.code === PlatformCode.AndroidNative) {
      dataStr = JSON.stringify(data, null, 2);
      triggerFileDownload(dataStr, `TerraService-${app.product.code}.json`);
    } else if (app.platform.code === PlatformCode.IOSNative) {
      dataStr = fromJson(data);
      triggerFileDownload(dataStr, `TerraService-Info.plist`);
    }

    return success(true);
  } else {
    return error(result.exception());
  }
}

export const triggerFileDownload = (content: string, fileName: string) => {
  const element = document.createElement('a');
  const file = new Blob([content], { type: 'text/plain' });
  element.href = URL.createObjectURL(file);
  element.download = fileName;
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
};
